export const FEATURE_OVERRIDE_ENABLED = "featureOverrideEnabled";
export const FEATURE_AB_TESTING = "ab";
export const FEATURE_DEALER_SEARCH_CHINA = "dealer_search_china";
export const FEATURE_NAVI_DRAWER_FROM_CDN = "navi_drawer_cdn";
export const FEATURE_CONTENT_V4 = "content_V4";
export const FEATURE_MPI_INTEGRATION = "mpi_integration";
export const FEATURE_MORE_INDICATOR = "more_indicator";
export const FEATURE_TEST_TOGGLE = "test_toggle";
